/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Card,
  Tabs,
  message,
  DatePicker,
  Tag,
  Typography,
} from 'antd';
import {
  EnvironmentOutlined,
  InfoCircleOutlined,
  QuestionCircleOutlined,
  CameraOutlined,
  FieldTimeOutlined,
  AlertOutlined,
  SearchOutlined,
  EllipsisOutlined,
  CloseCircleOutlined,
  FileDoneOutlined,
  IdcardOutlined,
  CarOutlined,
  PrinterOutlined,
  DeleteOutlined,
  // PrinterOutlined,
} from '@ant-design/icons';
import Direccion from 'components/Direccion';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import { onError } from 'utils/handlers';
import { isMutable } from 'utils/estadosGlobales';
import makeMessager from 'utils/complexFormsMessages';
import NumericInput from 'components/NumericInput';
import { InputSearchPro } from 'components/InputSearch';
import BusquedaAvanzadaPadron from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { makeGetOnFinish, makeOnChangeTabKey } from 'utils/tabsManagement';
import { getModelPermission } from 'utils/permission/index';
import Previewer from 'components/Previewer';
import {
  getCatalogoDePaises,
  getDocumentosDeRegularizacion,
  getTiposDeCombustibles,
  getUsosDeMotocicletas,
  getTiposDeTramitesVehiculares,
  getVersionesVehiculares,
} from 'api/catalogos';
import {
  getClasesDeVehiculos,
  getEstadosDeVehiculo,
  getLineasVehiculares,
  getMarcasDeVehiculos,
  getServiciosDelVehiculo,
  getTiposDeVehiculos,
  getColoresVehiculos,
} from 'api/recaudacion';
import { getDocumentosDeTramites } from 'api/empresas/documentosDeTramites';
import {
  deleteVehiculo,
  getVehiculo,
  getVehiculos,
  patchVehiculo,
  postVehiculo,
} from 'api/recaudacion/vehiculos';
import { getCiudadano } from 'api/cuentaunicasir';
import { getCiudadanoCaja } from 'api/cuentaunicasir/index';
import { patchCiudadano } from 'api/cuentaunicasir/ciudadanos';
import { getTiposDeTenencias } from 'api/recaudacion/tiposDeTenencias';
import { getUsuarios } from 'api/usuarios/usuarios';
import { getContribuyente, getContribuyenteCaja } from 'api/empresas/contribuyentes';
import ModalTramiteTarjeta from 'components/Catalogos/ModalTipoTramite';
import { capitalize, noSymbolsCapitalized } from 'utils/normalizers';
import BusquedaAvanzadaVersion from 'components/BusquedaAvanzadaVersion';
import { getVersionVehicular } from 'api/catalogos/versionVehicular';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import Moment from 'moment';
import { postObtenerReporte } from 'api/reporteador';
import { getUnidadesDeRecaudacion } from 'api/configuracion/unidadesDeRecaudacion';

import HistorialDePlacas, { permissionConfig as placasPermission } from 'components/Catalogos/HistorialDePlacas';
import DocumentosVehiculares, { permissionConfig as documentosVehicularesPermission } from 'components/Catalogos/DocumentosVehiculares';
import AlertasDelVehiculo, { permissionConfig as alertasDelVehiculoPermission } from 'components/Catalogos/AlertasDelVehiculo';

const { TabPane } = Tabs;
const baseURI = 'recaudacion/vehiculos/';

export const permissionConfig = {
  permissionModel: 'vehiculo',
  tabsModels: [
    placasPermission,
    documentosVehicularesPermission,
    alertasDelVehiculoPermission,
  ],
};

const Vehiculo = ({ permission, addressPermission }) => {
  const estadosGlobales = useSelector(({ catalogs }) => catalogs.estadosGlobales);
  const collapsedSideBar = useSelector(({ app }) => app.collapsedSidebar);
  const _entidad = useSelector(({ auth }) => auth.entidad);
  const [visibleTarjeta, setVisibleTarjeta] = useState(false);
  const [form] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [formFactura] = Form.useForm();
  const [formInfo] = Form.useForm();
  const [formDocumentos] = Form.useForm();
  const esForaneo = Form.useWatch('es_foraneo', formInfo);
  const marca = Form.useWatch('marca', formInfo);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [mutable, setMutable] = useState(true);

  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [formAddress, setFormAddress] = useState();
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState({ results: [] });
  const [servicio, setServicio] = useState([]);
  const [estadoDelVehiculo, setEstadoDelVehiculo] = useState([]);
  const [tipoDeVehiculo, setTipoDeVehiculo] = useState([]);
  const [colorVehiculo, setColorVehiculo] = useState([]);
  const [documentoTramite, setDocumentoTramite] = useState([]);
  const [claseDelVehiculo, setClaseDelVehiculo] = useState([]);
  const [ciudadanoFound, setCiudadanoFound] = useState([]);
  const [contribuyenteFound, setContribuyenteFound] = useState([]);
  const [base64, setBase64] = useState();
  const [isCiudadano, setIsCiudadano] = useState(false);
  const [visiblePreview, setVisiblePreview] = useState(false);
  const [clavesDeDocumento, setClavesDeDocumento] = useState([]);
  const [visibleBusquedaPadrones, setVisibleBusquedaPadrones] = useState(false);
  const [visibleBusqueda, setVisibleBusqueda] = useState(false);
  const [versionFound, setVersionFound] = useState([]);
  const [dataExterno, setDataExterno] = useState({ results: [] });
  const [tenencias, setTenencias] = useState([]);
  const [excento, setExcento] = useState(true);
  const [jefeFound, setJefeFound] = useState([]);
  const [permissions, setPermissions] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [tipoDeCombustible, setTipoDeCombustible] = useState([]);
  const [uso, setUso] = useState([]);
  const [tiposDeTramites, setTiposDeTramites] = useState([]);
  const [unidadesDeRecaudacion, setUnidadesDeRecaudacion] = useState([]);
  const [paisesTemp, setPaisesTemp] = useState({ results: [] });
  const [marcasTemp, setMarcasTemp] = useState({ results: [] });
  const [lineaTemp, setLineaTemp] = useState({ results: [] });
  const paises = useRef({ results: [] });
  const marcas = useRef({ results: [] });
  const linea = useRef({ results: [] });
  const [justView, setJustView] = useState(false);

  const PROD = process.env.REACT_APP_ENV === 'PRODUCTION';
  const ENV_NAME = process.env.REACT_APP_ENV_NAME;
  const REPUVE = ENV_NAME === 'repuve';

  const basicKeys = ['general', 'detalles', 'info', 'documentos', 'placas', 'alertas', 'facturacion', 'repuve'];
  const complexForms = [
    {
      key: 'direccion',
      formInstance: formAddress,
      permission: addressPermission,
    }];

  // const screen = useBreakpoint();

  const fetchData = async (page = 1, q = null) => {
    setLoading(true);
    setCurrentPage(page);
    const _data = await getVehiculos({
      ...q,
      page,
    });
    setData(_data);
    setLoading(false);
  };

  const showMsg = makeMessager(setCurrentTabKey, fetchData);

  const onCancel = () => {
    setVisible(false);
    formSearch.resetFields();
    form.resetFields();
    formInfo.resetFields();
    formDocumentos.resetFields();
    formFactura.resetFields();
    setSelectedRowKeys([]);
    setCurrentTabKey('general');
    setMutable(true);
    setCiudadanoFound([]);
    setContribuyenteFound([]);
    setJefeFound([]);
    setBase64();
    setExcento(true);
    marcas.current = { results: [] };
    linea.current = { results: [] };
    setMarcasTemp({ results: [] });
    setLineaTemp({ results: [] });
    setData({ results: [] });
    setJustView(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _servicios,
        _estados,
        _tipos,
        _coloresVehiculos,
        _clases,
        _documentosDeRegularizacion,
        _tenencias,
        _documentosTramites,
        _combustibles,
        _uso,
        _tiposDeTramitesVehiculares,
        _unidadesDeRecaudacion,
      ] = await Promise.all([
        getServiciosDelVehiculo(),
        getEstadosDeVehiculo(),
        getTiposDeVehiculos(),
        getColoresVehiculos(),
        getClasesDeVehiculos(),
        getDocumentosDeRegularizacion(),
        getTiposDeTenencias(),
        getDocumentosDeTramites(),
        getTiposDeCombustibles(),
        getUsosDeMotocicletas(),
        getTiposDeTramitesVehiculares(),
        getUnidadesDeRecaudacion(),
      ]);
      if (mounted) {
        setServicio(_servicios);
        setEstadoDelVehiculo(_estados);
        setTipoDeVehiculo(_tipos);
        setColorVehiculo(_coloresVehiculos);
        setClaseDelVehiculo(_clases);
        setClavesDeDocumento(_documentosDeRegularizacion);
        setTenencias(_tenencias);
        setDocumentoTramite(_documentosTramites);
        setTipoDeCombustible(_combustibles);
        setUso(_uso);
        setTiposDeTramites(_tiposDeTramitesVehiculares);
        setUnidadesDeRecaudacion(_unidadesDeRecaudacion);
        setLoading(false);
      }
    };
    const validatePermissions = () => {
      const documentosVehiculares = getModelPermission(documentosVehicularesPermission.model);
      const alertas = getModelPermission(alertasDelVehiculoPermission.model,
        alertasDelVehiculoPermission.catalogsModels);
      const placas = getModelPermission(placasPermission.model);
      if (mounted) {
        setPermissions({
          documentosVehiculares,
          alertas,
          placas,
        });
      }
    };
    validatePermissions();
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const fetchVersion = async (id) => {
    setLoading(true);
    if (id) {
      const _version = await getVersionVehicular(id?.id);
      if (_version) {
        const match = {
          ..._version,
          descripcion_completa: `${_version?.tipo_de_vehiculo_en_version} -
      ${_version?.marca_en_version} -
      ${_version?.linea_en_version} - 
      ${_version?.descripcion}`.replace(' - undefined', ''),
        };
        formInfo.setFieldsValue({
          version_vehicular: _version.id,
        });
        setVersionFound([match]);
      } else {
        setVersionFound([]);
      }
    }
    setLoading(false);
  };

  const fetchCiudadano = async (id) => {
    setLoading(true);
    if (id) {
      const _ciudadano = await getCiudadano(id);
      if (_ciudadano) {
        setCiudadanoFound([_ciudadano]);
      } else {
        message.info('No se encontró ciudadano');
      }
    }
    setLoading(false);
  };

  const fetchContribuyente = async (id) => {
    setLoading(true);
    if (id) {
      const _contribuyente = await getContribuyente(id);
      if (_contribuyente) {
        setContribuyenteFound([_contribuyente]);
      } else {
        message.info('No se encontró el Contribuyente');
      }
    }
    setLoading(false);
  };

  const onClickEdit = async (response) => {
    form.resetFields();
    formInfo.resetFields();
    formDocumentos.resetFields();
    formFactura.resetFields();
    const key = response?.id || selectedRowKeys[0];
    const match = await getVehiculo(key);
    setMutable(isMutable(match.estados_globales));
    setIsCiudadano(match.es_propietario_ciudadano);
    setExcento(match?.exento_de_pago_de_tenencia);
    setJefeFound(match.usuario_verificador);
    if (match) {
      if (match.linea) {
        const _linea = await getLineasVehiculares({ id: match.linea });
        setLineaTemp(_linea);
        const _marca = await getMarcasDeVehiculos({ id: _linea.results[0].marca });
        setMarcasTemp(_marca);
        match.marca = _linea.results[0].marca;
      }
      if (match?.propietario) {
        await fetchCiudadano(match?.propietario);
      }
      if (match?.contribuyente_propietario) {
        await fetchContribuyente(match?.contribuyente_propietario);
      }
      if (match?.es_foraneo) {
        const _paises = await getCatalogoDePaises({ id: match.pais });
        setPaisesTemp(_paises);
      }
      setTimeout(() => {
        form.setFieldsValue({ ...match });
        formInfo.setFieldsValue({ ...match });
        formDocumentos.setFieldsValue(match);
        formFactura.setFieldsValue(match);
        setVisible(true);
      });
    }
  };

  const setBaseAndShowPreview = (_base64) => {
    setBase64(_base64);
    setVisiblePreview(true);
  };

  const getReporteVehicular = async () => {
    setLoading(true);
    const current = data.results.find((item) => item.id === selectedRowKeys[0]);
    const values = {
      ID: PROD ? 225 : 220,
      Parametros: [{
        Nombre: 'clave_del_vehiculo',
        TipoParametro: 'Texto',
        Valor: current.clave,
      }],
    };
    const response = await postObtenerReporte(values);
    setBaseAndShowPreview(response);
    setLoading(false);
  };

  const content = (
    <>
      <Row justify="end">
        <Button
          type="link"
          style={{ color: '#000000', marginTop: -25 }}
          icon={<CloseCircleOutlined />}
          onClick={() => message.destroy()}
        />
      </Row>
      <strong>Hace falta buscar un propietario.</strong>
      <br />
      <span>
        Para buscar un propietario ubiquese en la pestaña
        {' '}
        <Tag
          icon={<InfoCircleOutlined style={{ color: '#000000', margin: 0 }} />}
          onClick={() => {
            setCurrentTabKey('info');
            message.destroy();
          }}
        >
          Información del Vehículo
        </Tag>
        seleccione a que padrón pertenece (Contribuyente o Ciudadano) y en el
        campo ubicado
        a la derecha introduzca algún dato del padrón correspondiente y presione el icono
        de búsqueda (
        <SearchOutlined style={{ color: '#000000', margin: 0 }} />
        ), en caso de que no se arroje alguna coincidencia presione el botón (
        <EllipsisOutlined style={{ color: '#000000', margin: 0 }} />
        ) para realizar una búsqueda avanzada.
      </span>
    </>
  );

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formInfo.validateFields();
      await formDocumentos.validateFields();
      await formFactura.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formInfo.getFieldsValue(),
        ...formDocumentos.getFieldsValue(),
        ...formFactura.getFieldsValue(),
      };
      if (isCiudadano) {
        values.contribuyente_propietario = null;
      } else {
        values.propietario = null;
      }
      if (values?.exento_de_pago_de_tenencia) {
        values.tipo_de_tenencia_vehicular = null;
      }

      if ((isCiudadano && !values?.propietario)
        || (!isCiudadano && !values?.contribuyente_propietario)) {
        message.info({ content, duration: 0 });
      } else {
        const [key] = selectedRowKeys;
        if (key) {
          values.fecha_del_ultimo_movimiento = new Moment();
        }
        const response = await (key
          ? patchVehiculo(key, values) : postVehiculo(values));
        if (response) {
          if (_continue) {
            if (!key) {
              setSelectedRowKeys([response.id]);
              onClickEdit(response);
              if (response?.comprobante) {
                setBaseAndShowPreview(response.comprobante);
              }
            } else {
              onClickEdit(response);
            }
          } else {
            onCancel();
          }
        }
      }
      setLoading(false);
      return true;
    } catch (err) {
      if (err?.errorFields?.length) {
        if (err.errorFields.some((e) => e.name[0] === 'q')) {
          message.info({ content, duration: 0 });
        }
      }
      onError(err, setLoading, [form, formInfo, formFactura, formDocumentos], setCurrentTabKey);
      return false;
    }
  };

  const deleteItem = async () => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const deleted = await deleteVehiculo(key);
    if (deleted) {
      setVisibleAlert(false);
      onCancel();
    }
    setLoading(false);
  };

  const handleOnRowClick = (record) => {
    setMutable(isMutable(record));
    setSelectedRowKeys([record.id]);
    setTimeout(() => {
      form.setFieldsValue(record);
      formInfo.setFieldsValue(record);
      formDocumentos.setFieldsValue(record);
    });
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const searchVersion = async () => {
    try {
      setLoading(true);
      await formInfo.validateFields(['q_version']);
      const { q } = formInfo.getFieldsValue(['q_version']);
      if (q) {
        const _version = await getVersionesVehiculares({ descripcion: q });
        if ([1].includes(_version.results.length)) {
          const [selected] = _version.results.map((e) => ({
            ...e,
            descripcion_completa: `${e?.tipo_de_vehiculo_en_version} -
            ${e?.marca_en_version} -
             ${e?.linea_en_version} -
             ${e?.descripcion}`.replace(' - undefined', ''),
          }));
          formInfo.setFieldsValue({
            version_vehicular: selected.id,
          });
          setVersionFound([selected]);
        } else if (_version.results.length > 1) {
          setDataExterno(_version);
          setVisibleBusqueda(true);
        } if (!_version.results.length) {
          message.info('No se encontró Versión Vehícular');
        }
      } else {
        await formInfo.validateFields(['q']);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 150,
    },
    {
      titleText: 'No. de Placa',
      dataIndex: 'numero_de_placa_vigente',
      key: 'numero_de_placa_vigente',
      width: 150,
    },
    {
      titleText: 'No. de Indentificación Vehícular',
      dataIndex: 'numero_de_identificacion_vehicular',
      key: 'numero_de_identificacion_vehicular',
      width: 250,
    },
    {
      titleText: 'Modelo del Vehículo',
      dataIndex: 'modelo',
      key: 'modelo',
      width: 200,
    },
    {
      titleText: 'Tarjeta de Circulación',
      dataIndex: 'tarjeta_de_circulacion',
      key: 'tarjeta_de_circulacion',
      width: 200,
    },
    {
      titleText: 'Clave de Repuve',
      dataIndex: 'clave_de_repuve',
      key: 'clave_de_repuve',
      width: 200,
    },
    {
      titleText: 'Servicio',
      dataIndex: 'servicio',
      key: 'servicio',
      width: 200,
      catalog: {
        cat: servicio,
        labelProp: 'nombre',
        use: true,
      },
    },
    {
      titleText: 'Estatus del Vehìculo',
      dataIndex: 'estatus_del_vehiculo',
      key: 'estatus_del_vehiculo',
      width: 200,
      catalog: {
        cat: estadoDelVehiculo,
        labelProp: 'nombre',
        use: true,
      },
    },
    {
      titleText: 'Tipo de Vehìculo',
      dataIndex: 'tipo_de_vehiculo',
      key: 'tipo_de_vehiculo',
      width: 200,
      catalog: {
        cat: tipoDeVehiculo,
        labelProp: 'nombre',
        use: true,
      },
    },
  ];

  const rules = {
    required: [{ required: true }],
    archivos: [
      {
        validator: async () => {
          const { factura_del_vehiculo, pedimento_del_vehiculo } = formInfo.getFieldsValue();
          if (factura_del_vehiculo?.fileList?.length
            && pedimento_del_vehiculo?.fileList?.length) {
            throw new Error('Solo es necesario la factura o el pedimento');
          }
        },
      },
    ],
  };

  const resetAndValidate = () => {
    setContribuyenteFound([]);
    setCiudadanoFound([]);
    formInfo.resetFields(['q']);
    formInfo.validateFields(['q']);
  };

  const resetAndValidateVersion = () => {
    setVersionFound([]);
    formInfo.resetFields(['q_version']);
  };

  const searchCiudadano = async () => {
    try {
      setLoading(true);
      await form.validateFields(['q']);
      const { q } = form.getFieldsValue(['q']);
      if (q) {
        const _ciudadanos = await getCiudadanoCaja({ q });
        if ([1].includes(_ciudadanos.results.length)) {
          const [selected] = _ciudadanos.results;
          form.setFieldsValue({
            propietario: selected.id,
          });
          setCiudadanoFound([selected]);
        } else if (_ciudadanos.results.length > 1) {
          setDataExterno(_ciudadanos);
          setVisibleBusquedaPadrones(true);
        } if (!_ciudadanos.results.length) {
          message.info('No se encontró ciudadano');
        }
      } else {
        await form.validateFields(['q']);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const busquedaJefe = async () => {
    try {
      setLoading(true);
      await form.validateFields(['q_jefe']);
      const { q_jefe: email } = form.getFieldsValue();
      if (email) {
        const _usuarios = await getUsuarios({ email });
        if (_usuarios.length) {
          form.setFieldsValue({
            usuario_verificador: _usuarios[0].id,
          });
          const results = _usuarios.map((e) => ({
            ...e,
            nombre_completo_usuario: `${e?.first_name} ${e?.last_name || ''} ${e?.second_last_name || ''}`,
          }));
          setJefeFound([results[0]]);
        } else {
          message.info('No se encontraron coincidencias');
          setJefeFound([]);
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys,
    complexForms,
    currentTabKey,
    setCurrentTabKey,
    showMsg,
  );

  const getOnFinish = makeGetOnFinish(basicKeys, complexForms, currentTabKey, onFinish);

  const resetAndValidateJefe = () => {
    setJefeFound([]);
    form.resetFields(['usuario_verificador']);
    form.validateFields(['usuario_verificador']);
  };
  const searchContribuyente = async () => {
    try {
      setLoading(true);
      await form.validateFields(['q']);
      const { q } = form.getFieldsValue(['q']);
      if (q) {
        const _contribuyente = await getContribuyenteCaja({ q });
        if (_contribuyente?.results?.length === 1) {
          const [selected] = _contribuyente.results;
          form.setFieldsValue({
            contribuyente_propietario: selected.id,
          });
          setContribuyenteFound([selected]);
        } else if (_contribuyente.results.length > 1) {
          setDataExterno(_contribuyente);
          setVisibleBusquedaPadrones(true);
        } if (!_contribuyente.results.length) {
          message.info('No se encontró Contribuyente');
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const perteneceOptions = [
    {
      id: true,
      descripcion: 'Ciudadano',
    },
    {
      id: false,
      descripcion: 'Contribuyente',
    },
  ];

  const handleSearch = async () => {
    try {
      setLoading(true);
      await formSearch.validateFields();
      const params = formSearch.getFieldsValue();
      const keys = Object.keys(params);
      const validProps = keys.filter((prop) => params[prop]);
      if (validProps?.length) {
        const _data = await getVehiculos(params);
        setData(_data);
      } else {
        message.warn('Debe ingresar al menos un campo.');
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const wipe = () => {
    formSearch.resetFields();
    setData({ results: [] });
  };

  // const allowSearch = screen.md || screen.lg || screen.xl || screen.xxl;

  const asignarEntidad = async (user) => {
    setLoading(true);
    const { razon_social } = _entidad;
    const { entidad, nombre_completo, id } = user;
    entidad.push(entidad.id);
    await patchCiudadano(
      id,
      { entidad },
      `Ahora el usuario ${nombre_completo} también pertenece a ${razon_social}.`,
    );
    setLoading(false);
  };

  const msgAsignarEntidad = (user) => (
    message.info({
      content: (
        <>
          <Row style={{ width: '100%' }}>
            El ciudadano no pertenece a la entidad.
          </Row>
          <Row justify="center">
            <strong style={{ marginRight: 3 }}>
              ¿Desea asignarlo a esta entidad?
            </strong>
          </Row>
          <Row align="middle" justify="center" style={{ width: '100%' }}>
            <Button
              type="link"
              onClick={() => asignarEntidad(user)}
            >
              Si
            </Button>
            <Button
              onClick={() => {
                message.destroy();
                form.resetFields();
              }}
              type="link"
            >
              No
            </Button>
          </Row>
        </>

      ),
      duration: 0,
    })
  );

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!visible && (
          <>
            <Form
              layout="vertical"
              form={formSearch}
              scrollToFirstError
              onFinish={() => handleSearch()}
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={6}>
                  <Form.Item
                    label="Clave"
                    name="clave"
                    normalize={capitalize}
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={6}>
                  <Form.Item
                    label="Numero de Placa"
                    name="placa_vieja"
                    normalize={capitalize}
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={6}>
                  <Form.Item
                    label="Serie"
                    tooltip="Número de Identificación Vehícular"
                    name="numero_de_identificacion_vehicular"
                    normalize={capitalize}
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                {REPUVE && (

                <Col xs={24} sm={24} md={6}>
                  <Form.Item
                    label="Clave de Repuve"
                    name="clave_de_repuve"
                    normalize={capitalize}
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                )}

                <Col xs={24} sm={24} md={6}>
                  <Form.Item
                    label="Tarjeta de Circulación"
                    name="tarjeta_de_circulacion"
                    normalize={capitalize}
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={6}>
                  <Button
                    onClick={handleSearch}
                    block
                    style={{ marginTop: 21 }}
                  >
                    <SearchOutlined />
                    <Typography.Text>
                      Buscar
                    </Typography.Text>
                  </Button>
                </Col>
                <Col xs={24} sm={24} md={6}>
                  <Button
                    onClick={wipe}
                    block
                    style={{ marginTop: 21 }}
                  >
                    <DeleteOutlined />
                    <Typography.Text>
                      Limpiar Busqueda
                    </Typography.Text>
                  </Button>
                </Col>
              </Row>
            </Form>
            <Table
              cols={columns}
              data={data?.results}
              rowSelection={rowSelection}
              handleOnRowClick={handleOnRowClick}
              customActions={[
                {
                  onClick: () => setVisibleTarjeta(true),
                  icon: <PrinterOutlined />,
                  text: 'Imprimir Tarjeta de Circulación',
                  disabledBySelection: true,
                },
                {
                  onClick: () => getReporteVehicular(),
                  icon: <PrinterOutlined />,
                  text: 'Reporte Auxiliar Histórico',
                  disabledBySelection: true,
                },
              ]}
              controls={{
                onClickAdd,
                onClickEdit,
                onClickDelete,
                onClickExpand: async () => {
                  await onClickEdit();
                  setJustView(true);
                },
              }}
              rowKey="id"
              baseURI={baseURI}
              allowImport
              allowExpand
              mobileColIndex={0}
              allowColumnSelector={false}
              allowSearch={false}
              permission={permission}
              pagination={false}
              paginationCallback={fetchData}
              count={data.count}
              currentPage={currentPage}
            />
          </>
        )}
        {visible && (
          <Col span={24}>
            <Card
              className="form-container"
              title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Vehículo`}
              extra={(
                <FormSubmitControls
                  onFinish={justView ? null : getOnFinish()}
                  onCancel={onCancel}
                  mutable={mutable}
                  allowSaveAndContinue={!justView}
                  onCancelText="Cancelar"
                  permission={permission}
                />
              )}
              bordered={false}
            >
              <Tabs
                onChange={mutable ? onChangeTabKey : setCurrentTabKey}
                activeKey={currentTabKey}
                type="card"
              >
                <TabPane
                  tab={(
                    <span>
                      <IdcardOutlined />
                      Información General
                    </span>
                  )}
                  key="general"
                  forceRender
                >
                  <Form
                    name="general"
                    layout="vertical"
                    form={form}
                    onFinish={() => onFinish()}
                    scrollToFirstError
                    initialValues={{ es_propietario_ciudadano: false }}
                  >
                    <Row gutter={10}>
                      {!!selectedRowKeys.length && (
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="clave"
                            label="Clave"
                            hasFeedback
                            allowClear
                            normalize={capitalize}
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                      )}
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="numero_de_placa_vigente"
                          label="Número de Placa"
                          hasFeedback
                          normalize={noSymbolsCapitalized}
                        >
                          <Input allowClear maxLength={10} disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="fecha_de_expiracion_de_la_placa"
                          label="Fecha de expiración de la placa"
                          hasFeedback
                        >
                          <DatePicker placeholder="" format={DATE_FRONTEND_FORMAT} disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipo_de_vehiculo"
                          label="Tipo de Vehículo"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select
                            dataSource={tipoDeVehiculo}
                            labelProp="nombre"
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="numero_economico"
                          label="Número Económico"
                        >
                          <Input allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="numero_de_identificacion_vehicular"
                          tooltip="Número de Identificación Vehícular"
                          label="Serie"
                          rules={rules.required}
                          hasFeedback
                          normalize={capitalize}
                        >
                          <Input allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="unidad_de_recaudacion"
                          label="Unidad de Recaudación"
                          rules={rules.required}
                        >
                          <Select
                            disabled={!mutable || justView}
                            dataSource={unidadesDeRecaudacion}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tarjeta_de_circulacion"
                          label="Tarjeta de Circulación"
                          hasFeedback
                          normalize={capitalize}
                        >
                          <Input allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="es_propietario_ciudadano"
                          label="Pertenece a"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select
                            dataSource={perteneceOptions}
                            onChange={setIsCiudadano}
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      {isCiudadano ? (
                        <InputSearchPro
                          disabled={!mutable || justView}
                          tooltip="Búsqueda por correo"
                          label="Ciudadano Propietario"
                          name="q"
                          rules={rules.required}
                          onClickAdvanced={() => setVisibleBusquedaPadrones(true)}
                          breakPoints={{
                            xs: 24,
                            sm: 24,
                            md: 16,
                          }}
                          inputProps={{
                            onPressEnter: () => searchCiudadano(),
                            onChange: ({ target: { value } }) => {
                              if (!value) {
                                resetAndValidate();
                              }
                            },
                          }}
                          resultProps={{
                            name: 'propietario',
                            label: 'Propietario',
                            dataSource: ciudadanoFound,
                            labelProp: 'nombre_completo',
                            onClear: resetAndValidate,
                            breakPoints: {
                              xs: 24,
                              sm: 24,
                              md: 16,
                            },
                          }}
                        />
                      ) : (
                        <InputSearchPro
                          disabled={!mutable || justView}
                          tooltip="Búsqueda por Nombre Completo"
                          label="Contribuyente Propietario"
                          onClickAdvanced={() => setVisibleBusquedaPadrones(true)}
                          name="q"
                          rules={rules.required}
                          breakPoints={{
                            xs: 24,
                            sm: 24,
                            md: 16,
                          }}
                          inputProps={{
                            onPressEnter: () => searchContribuyente(),
                            onChange: ({ target: { value } }) => {
                              if (!value) {
                                resetAndValidate();
                              }
                            },
                          }}
                          resultProps={{
                            breakPoints: {
                              xs: 24,
                              sm: 24,
                              md: 16,
                            },
                            name: 'contribuyente_propietario',
                            label: 'Contribuyente Propietario',
                            dataSource: contribuyenteFound,
                            labelProp: contribuyenteFound[0]?.nombre_completo ? 'nombre_completo' : 'razon_social',
                            onClear: resetAndValidate,
                          }}
                        />
                      )}
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="clave_de_repuve"
                          label="Clave de Repuve"
                          tooltip="Registro Público Vehícular"
                          hasFeedback
                          normalize={capitalize}
                        >
                          <Input allowClear maxLength={17} disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="clave_de_servicio_publico"
                          label="Servicio Público"
                          tooltip="Clave del Servicio Público"
                          hasFeedback
                          normalize={capitalize}
                        >
                          <Input allowClear maxLength={10} disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col md={8} sm={24} xs={24}>
                        <NumericInput
                          name="capacidad_de_carga"
                          label="Capacidad de Carga"
                          tooltip="Capacidad de carga del vehículo."
                          disabled={!mutable || justView}
                          decimal
                          required
                        />
                      </Col>
                      <Col md={8} sm={24} xs={24}>
                        <NumericInput
                          name="capacidad_de_pasajeros"
                          label="Capacidad de Pasajeros"
                          tooltip="Número de pasajeros para los que diseño el vehículo."
                          disabled={!mutable || justView}
                          required
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="registro_publico_vehicular"
                          label="Registro Público Vehícular"
                          hasFeedback
                          normalize={capitalize}
                        >
                          <Input allowClear maxLength={17} disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col md={8} sm={24} xs={24}>
                        <NumericInput
                          name="verificacion_tecnica_vehicular"
                          label="Verificación Técnica Vehícular"
                          disabled={!mutable || justView}
                        />
                      </Col>
                      <InputSearchPro
                        label={collapsedSideBar ? 'Verficador' : 'Usuario Verificador'}
                        tooltip={collapsedSideBar ? 'Busqueda de Usuario verificador por email' : 'Búsqueda por Email'}
                        name="q_jefe"
                        rules={rules.email}
                        onPressEnter={() => busquedaJefe()}
                        disabled={!mutable || justView}
                        breakPoints={{
                          xs: 24,
                          sm: 24,
                          md: 24,
                          lg: 8,
                        }}
                        inputProps={{
                          onPressEnter: () => busquedaJefe(),
                          onChange: ({ target: { value } }) => {
                            if (!value) {
                              resetAndValidateJefe();
                            }
                          },
                        }}
                        resultProps={{
                          name: 'usuario_verificador',
                          label: 'Usuario Verificador',
                          dataSource: jefeFound,
                          labelProp: 'nombre_completo_usuario',
                          onClear: resetAndValidateJefe,
                          breakPoints: {
                            md: 8,
                          },
                        }}
                      />
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="es_fronterizo"
                          label="¿Es Fronterizo?"
                          hasFeedback
                        >
                          <Select
                            trueFalse
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="fecha_del_ultimo_movimiento"
                          label="Fecha del último movimiento"
                          hasFeedback
                        >
                          <DatePicker
                            placeholder=""
                            format={DATE_FRONTEND_FORMAT}
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipo_de_tramite_vehicular"
                          label="Tipo de trámite vehícular"
                          hasFeedback
                        >
                          <Select
                            dataSource={tiposDeTramites}
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="estados_globales"
                          label="Estado"
                          hasFeedback
                        >
                          <Select
                            disabled
                            dataSource={estadosGlobales}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Form.Item hidden>
                      <Button htmlType="submit" />
                    </Form.Item>
                  </Form>
                </TabPane>
                <TabPane
                  tab={(
                    <>
                      <InfoCircleOutlined />
                      Información del Vehículo
                    </>
                  )}
                  key="info"
                  forceRender
                >
                  <Form
                    name="info"
                    layout="vertical"
                    form={formInfo}
                    onFinish={() => onFinish()}
                    scrollToFirstError
                    initialValues={{
                      es_propietario_ciudadano: false,
                      exento_de_pago_de_tenencia: true,
                    }}
                  >
                    <Row gutter={10}>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="marca"
                          label="Marca"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select
                            disabled={!mutable || justView}
                            dataSource={marcasTemp.results?.length ? marcasTemp : marcas.current}
                            usingExternalDataSource={Boolean(marcasTemp.results?.length)}
                            labelProp="nombre"
                            onClear={() => {
                              formInfo.resetFields(['linea', 'version_vehicular']);
                              setMarcasTemp({ results: [] });
                              setLineaTemp({ results: [] });
                            }}
                            onChange={() => {
                              formInfo.resetFields(['linea', 'version_vehicular']);
                              setMarcasTemp({ results: [] });
                              setLineaTemp({ results: [] });
                            }}
                            pagination={{
                              getter: getMarcasDeVehiculos,
                              setter: (dataSource) => {
                                marcas.current = dataSource;
                              },
                              config: { auto: true, qName: 'nombre' },
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="linea"
                          label="Línea"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select
                            disabled={!mutable || justView || !marca}
                            dataSource={lineaTemp.results?.length ? lineaTemp : linea.current}
                            usingExternalDataSource={Boolean(lineaTemp.results?.length)}
                            labelProp="nombre"
                            pagination={{
                              getter: getLineasVehiculares,
                              setter: (dataSource) => {
                                linea.current = dataSource;
                              },
                              params: { marca },
                              config: { auto: true, qName: 'nombre' },
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <InputSearchPro
                        disabled={!mutable || justView}
                        tooltip="Búsqueda por descripcion"
                        label="Versión Vehícular"
                        name="q_version"
                        onClickAdvanced={() => setVisibleBusqueda(true)}
                        breakPoints={{
                          xs: 24,
                          sm: 24,
                          md: 8,
                        }}
                        inputProps={{
                          onPressEnter: () => searchVersion(),
                          onChange: ({ target: { value } }) => {
                            if (!value) {
                              resetAndValidateVersion();
                            }
                          },
                        }}
                        resultProps={{
                          name: 'version_vehicular',
                          label: 'Versión Vehícular',
                          dataSource: versionFound,
                          labelProp: 'descripcion_completa',
                          onClear: resetAndValidateVersion,
                          breakPoints: {
                            xs: 24,
                            sm: 24,
                            md: 8,
                          },
                        }}
                      />
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="modelo"
                          label="Modelo"
                          tooltip={{
                            title: 'Año del vehículo',
                            icon: <QuestionCircleOutlined />,
                          }}
                          disabled={!mutable || justView}
                          required
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="clase_del_vehiculo"
                          label="Clase del Vehículo"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select
                            dataSource={claseDelVehiculo}
                            labelProp="nombre"
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="color_secundario"
                          label="Color Secundario"
                          hasFeedback
                          normalize={capitalize}
                        >
                          <Input
                            allowClear
                            disabled={!mutable || justView}

                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="color_del_vehiculo"
                          label="Color del Vehículo"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select
                            dataSource={colorVehiculo}
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="servicio"
                          label="Servicio"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select dataSource={servicio} labelProp="nombre" disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="es_foraneo"
                          label="¿Es Foráneo?"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select
                            trueFalse
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      {!!esForaneo && (
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="pais"
                            label="País"
                            hasFeedback
                          >
                            <Select
                              disabled={!mutable || justView}
                              dataSource={paisesTemp.results?.length ? paisesTemp : paises.current}
                              usingExternalDataSource={Boolean(paisesTemp.results?.length)}
                              labelProp="descripcion"
                              onClear={() => form.resetFields(['pais'])}
                              pagination={{
                                getter: getCatalogoDePaises,
                                setter: (dataSource) => {
                                  paises.current = dataSource;
                                },
                                config: { auto: true, qName: 'descripcion' },
                              }}
                            />
                          </Form.Item>
                        </Col>
                      )}
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="exento_de_pago_de_tenencia"
                          label="¿Exento de pago de tenencia?"
                          hasFeedback
                        // rules={rules.required}
                        >
                          <Select
                            trueFalse
                            disabled={!mutable || justView}
                            onChange={setExcento}
                          />
                        </Form.Item>
                      </Col>
                      {!excento && (
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_tenencia_vehicular"
                            label="Tipo de tenencia"
                            hasFeedback
                            rules={rules.required}
                          >
                            <Select
                              dataSource={tenencias}
                              disabled={!mutable || justView}
                              keyLabelRender
                            />
                          </Form.Item>
                        </Col>
                      )}
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="uso_del_vehiculo"
                          label="Uso del Vehículo"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select
                            dataSource={uso}
                            disabled={!mutable || justView}
                            keyProp="clave"
                            labelProp="descripcion"
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="estatus_del_vehiculo"
                          label="Estatus del Vehículo"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select
                            dataSource={estadoDelVehiculo}
                            labelProp="nombre"
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="numero_de_chasis"
                          label="Número de Chasis"
                          hasFeedback
                          normalize={capitalize}
                        >
                          <Input allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="numero_de_motor"
                          label="Número de motor"
                          hasFeedback
                          normalize={capitalize}
                          rules={rules.required}
                        >
                          <Input allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="numero_de_puertas"
                          label="Número de puertas"
                          hasFeedback
                          normalize={capitalize}
                          rules={rules.required}
                        >
                          <Input allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="cilindraje"
                          label="Cilindraje"
                          disabled={!mutable || justView}
                          decimal
                          required
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipo_de_combustible"
                          label="Tipo de Combustible"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select disabled={!mutable || justView} dataSource={tipoDeCombustible} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="numero_de_calcomania"
                          label="Número de calcomanía"
                          hasFeedback
                          normalize={capitalize}
                        >
                          <Input allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="peso_del_vehiculo"
                          label="Peso del Vehículo"
                          disabled={!mutable || justView}
                          decimal
                        />
                      </Col>
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          name="observaciones"
                          label="Observaciones"
                          hasFeedback
                          normalize={capitalize}
                        >
                          <Input.TextArea
                            autoSize={{ minRows: 3, maxRows: 3 }}
                            allowClear
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Form.Item hidden>
                      <Button htmlType="submit" />
                    </Form.Item>
                  </Form>
                </TabPane>
                <TabPane
                  tab={(
                    <>
                      <FileDoneOutlined />
                      Facturación
                    </>
                  )}
                  key="facturacion"
                  forceRender={selectedRowKeys.length}
                >
                  <Form
                    name="facturacion"
                    layout="vertical"
                    form={formFactura}
                    onFinish={() => onFinish()}
                    scrollToFirstError
                  >
                    <Row gutter={10}>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="clave_del_documento_de_regularizacion"
                          label="Clave de Documento"
                          hasFeedback
                        >
                          <Select
                            disabled={!mutable || justView}
                            dataSource={clavesDeDocumento}
                            keyLabelRender
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="documentos_de_tramite"
                          label="Documento del Trámite"
                          hasFeedback
                        >
                          <Select
                            dataSource={documentoTramite}
                            keyLabelRender
                            keyProp="clave"
                            labelProp="descripcion"
                            mode="multiple"
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="es_vehiculo_nacional"
                          label="Procedencia del Vehículo"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select
                            disabled={!mutable || justView}
                            dataSource={[
                              {
                                id: true,
                                descripcion: 'Nacional',
                              },
                              {
                                id: false,
                                descripcion: 'Extranjero',
                              },
                            ]}
                            labelProp="descripcion"
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="importe_de_la_factura"
                          label="Importe de la factura"
                          disabled={!mutable || justView}
                          decimal
                          required
                          onChange={(importe_de_la_factura) => form
                            .setFieldsValue({ importe_de_la_factura })}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="fecha_de_la_factura"
                          label="Fecha de la Factura"
                          hasFeedback
                          rules={rules.required}
                        >
                          <DatePicker
                            placeholder=""
                            format={DATE_FRONTEND_FORMAT}
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="numero_de_factura"
                          label="Nofac"
                          hasFeedback
                          normalize={capitalize}
                          rules={rules.required}
                        >
                          <Input allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="rfc_emisor_cfdi"
                          label="RFC Emisor CFDI"
                          hasFeedback
                          normalize={noSymbolsCapitalized}
                          rules={rules.required}
                        >
                          <Input maxLength={13} allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="registro_publico_vehicular"
                          label="Registro Público Vehícular"
                          hasFeedback
                          normalize={capitalize}
                        >
                          <Input allowClear maxLength={17} disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>

                    </Row>
                    <Form.Item hidden>
                      <Button htmlType="submit" />
                    </Form.Item>
                  </Form>
                </TabPane>
                <TabPane
                  tab={(
                    <>
                      <CarOutlined />
                      Repuve
                    </>
                  )}
                  key="repuve"
                  forceRender={selectedRowKeys.length}
                >
                  <Form
                    name="general"
                    layout="vertical"
                    form={form}
                    onFinish={() => onFinish()}
                    scrollToFirstError
                  >
                    <Row gutter={10}>
                      {!!selectedRowKeys.length && (
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="clave"
                            label="Clave"
                            hasFeedback
                            allowClear
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                      )}
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="fecha_de_repuve"
                          label="Fecha de Repuve"
                          hasFeedback
                        >
                          <DatePicker
                            placeholder=""
                            format={DATE_FRONTEND_FORMAT}
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          name="tipo_de_movimiento_repuve"
                          label="Tipo de Movimiento Repuve"
                          hasFeedback
                        >
                          <Input.TextArea
                            autoSize={{ minRows: 3, maxRows: 3 }}
                            allowClear
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          name="descripcion_de_la_agencia"
                          label="Agencia Distribuidora"
                          hasFeedback
                        >
                          <Input.TextArea
                            autoSize={{ minRows: 3, maxRows: 3 }}
                            allowClear
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          name="clave_de_la_secretaria_de_hacienda_y_credito_publico"
                          label="Clave de la Secretaría de Hacienda y Crédito Público"
                          hasFeedback
                          normalize={capitalize}
                        >
                          <Input allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="web_service"
                          label="Servicio Web"
                          hasFeedback
                        >
                          <Select trueFalse disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="aduana"
                          label="Aduana"
                          tooltip="Número de la seccion de la Aduana"
                          disabled={!mutable || justView}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="nombre_de_la_aduana"
                          label="Nombre de la Aduana"
                          hasFeedback
                          normalize={capitalize}
                        >
                          <Input allowClear />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="numero_de_patente"
                          label="Número de Patente"
                          hasFeedback
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="numero_de_pedimento"
                          label="Número de Pedimento"
                          disabled={!mutable || justView}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="fecha_de_pedimento"
                          label="Fecha de Pedimento"
                          hasFeedback
                        >
                          <DatePicker
                            placeholder=""
                            format={DATE_FRONTEND_FORMAT}
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="clave_del_importador"
                          label="Clave del Importador"
                          hasFeedback
                        >
                          <NumericInput disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Form.Item hidden>
                      <Button htmlType="submit" />
                    </Form.Item>
                  </Form>
                </TabPane>
                {addressPermission?.view && (
                  <TabPane
                    tab={(
                      <>
                        <EnvironmentOutlined />
                        Dirección
                      </>
                    )}
                    key="direccion"
                    forceRender
                    disabled={!selectedRowKeys.length}
                  >
                    <Direccion
                      mutable={mutable && !justView}
                      currentURI={baseURI}
                      parentID={selectedRowKeys[0]}
                      setLoading={setLoading}
                      onError={onError}
                      setFormAddress={setFormAddress}
                      setCurrentTabKey={setCurrentTabKey}
                      permission={addressPermission}
                      callback={(values, _continue) => {
                        if (!_continue) {
                          onCancel();
                        } else {
                          const [key] = selectedRowKeys;
                          const clone = [...data];
                          const mappedData = clone.map((e) => (e.id === key
                            ? ({ ...e, direccion: values?.id }) : e));
                          setData(mappedData);
                        }
                      }}
                    />
                  </TabPane>
                )}
                {permissions?.placas?.view && (
                  <TabPane
                    tab={(
                      <>
                        <FieldTimeOutlined />
                        Historial de Placas
                      </>
                    )}
                    key="placas"
                    disabled={!selectedRowKeys.length || justView}
                    forceRender={selectedRowKeys.length}
                  >
                    <HistorialDePlacas
                      vehiculoId={selectedRowKeys[0]}
                      permission={permissions?.placas}
                      esPropietarioCiudadano={isCiudadano}
                      contribuyentePropietarioId={contribuyenteFound[0]?.id}
                      ciudadanoPropietarioId={ciudadanoFound[0]?.id}
                      setCurrentTabKey={setCurrentTabKey}
                      justView={justView}
                      callback={onClickEdit}
                    />
                  </TabPane>
                )}
                {permissions?.documentos?.view && (
                  <TabPane
                    tab={(
                      <>
                        <CameraOutlined />
                        Fotos
                      </>
                    )}
                    key="documentos"
                    disabled={!selectedRowKeys.length || justView}
                    forceRender={selectedRowKeys.length}
                  >
                    <DocumentosVehiculares
                      vehiculoId={selectedRowKeys[0]}
                      permission={permissions?.documentos}
                    />
                  </TabPane>
                )}
                {permissions?.alertas?.view && (
                  <TabPane
                    tab={(
                      <>
                        <AlertOutlined />
                        Alertas
                      </>
                    )}
                    key="alertas"
                    disabled={!selectedRowKeys.length}
                    forceRender={selectedRowKeys.length || justView}
                  >
                    <AlertasDelVehiculo vehiculoId={selectedRowKeys[0]} />
                  </TabPane>
                )}
              </Tabs>
            </Card>
          </Col>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          visible={visibleAlert}
          content="Vehículo Seleccionado?"
          loading={loading}
        />
        <Previewer
          visible={visiblePreview}
          setVisible={setVisiblePreview}
          base64={base64}
        />
        <BusquedaAvanzadaPadron
          visible={visibleBusquedaPadrones}
          setVisible={setVisibleBusquedaPadrones}
          callback={(found) => {
            if (isCiudadano) {
              setCiudadanoFound([found]);
              form.setFieldsValue({ propietario: found.id });
            } else {
              setContribuyenteFound([found]);
              form.setFieldsValue({ contribuyente_propietario: found.id });
            }
          }}
          dataExterno={dataExterno}
          setDataExterno={setDataExterno}
          tipoDePadron={isCiudadano ? 1 : 15}
          msgAsignarEntidad={msgAsignarEntidad}
          allowAdd={false}
        />
        <ModalTramiteTarjeta
          visible={visibleTarjeta}
          setVisible={setVisibleTarjeta}
          selectedRowKey={selectedRowKeys[0]}
        />
        <BusquedaAvanzadaVersion
          visible={visibleBusqueda}
          setVisible={setVisibleBusqueda}
          callback={fetchVersion}
          dataExterno={dataExterno}
          setDataExterno={setDataExterno}
        />
      </Spin>
    </Row>
  );
};

export default Vehiculo;
